<template>
    <div style="background:#fff;">
        <v-container>
            <v-row class="mt-8">
                <v-col cols="12" sm="12" md="6" lg="6">
                    

                    <h1 v-if="$vuetify.breakpoint.mdAndUp" class="rfont-38 weight-semibold darkergray--text" 
                        style="line-height:1.3"                        
                    >
                        The World Has Changed.<br v-if="$vuetify.breakpoint.mdAndUp ">It's time your healthcare services caught up!
                    </h1>
                    <h1 v-else class="rfont-40 weight-semibold darkergray--text text-center" 
                        style="line-height:1.3"
                    >
                        The World Has Changed. It's time your healthcare services caught up!
                    </h1>
                    <h6 class="rfont-22 weight-medium darkergray--text mt-5 text-center text-md-left" style="line-height:1.5;">
                        HeatlhyAlways provides you with an affordable way to access your doctors & healthcare professionals anytime you need them.
                    </h6>
                    <div class="mt-8 d-md-flex"
                        v-if="$vuetify.breakpoint.mdAndUp"
                    >
                    
                        <span 
                            @click="$router.push('search-doctor?clinic=1')"
                            class="d-inline-flex align-center px-3 py-1 rounded cursor-pointer"
                            style="background-color:#C8E2FF;min-height:34px;"
                        >
                            <v-img
                                width="16"
                                src="/general/hospital-sign.png"                                                                     
                            ></v-img>
                            <span                                
                                class="rfont-16 weight-medium ml-2"
                            >
                                Clinic Appointment
                            </span>
                        </span>

                        <span 
                            @click="$router.push('search-doctor?video=1')"
                            class="d-inline-flex align-center px-3 py-1 rounded ml-2 cursor-pointer"
                            style="background-color:#E7F5E7;min-height:34px;"
                        >
                            <v-img
                                width="16"
                                src="/general/ic_video.png"                                                                     
                            ></v-img>
                            <span                                
                                class="rfont-16 weight-medium ml-2"
                            >Video Consultation</span>
                        </span>

                        <span
                            @click="$router.push('ask-a-question')"
                            class="d-inline-flex align-center px-3 py-1 rounded ml-2 cursor-pointer"
                            style="background-color:#F6E7D0;min-height:34px"
                        >
                            <v-img
                                width="16"
                                aspect-ratio
                                src="/general/ic_question.png"                                                                     
                            ></v-img>
                            <span                                
                                class="rfont-16 weight-medium ml-2"
                            >Ask A Question</span>
                        </span>
                    </div>

                    <div class="mt-6 emulated-flex-gap justify-center"
                        v-else                        
                        style="display:flex;flex-wrap:wrap;"
                    >
                        <span 
                            @click="$router.push('search-doctor?clinic=1')"
                            class="d-inline-flex align-center px-2 py-1 rounded cursor-pointer"
                            style="background-color:#C8E2FF;min-height:34px;"
                        >
                            <v-img
                                width="12"
                                src="/general/hospital-sign.png"                                                                     
                            ></v-img>
                            <span                                
                                class="rfont-12 weight-medium ml-2"
                            >
                                Clinic Appointment
                            </span>
                        </span>

                        <span 
                            @click="$router.push('search-doctor?video=1')"
                            class="d-inline-flex align-center px-2 py-1 rounded cursor-pointer"
                            style="background-color:#E7F5E7;min-height:34px;"
                        >
                            <v-img
                                width="12"
                                src="/general/ic_video.png"                                                                     
                            ></v-img>
                            <span                                
                                class="rfont-12 weight-medium ml-2"
                            >Video Consultation</span>
                        </span>

                        <span 
                            @click="$router.push('ask-a-question')"
                            class="d-inline-flex align-center px-2 py-1 rounded cursor-pointer"
                            style="background-color:#F6E7D0;min-height:34px"
                        >
                            <v-img
                                width="12"
                                aspect-ratio
                                src="/general/ic_question.png"                                                                     
                            ></v-img>
                            <span                                
                                class="rfont-12 weight-medium ml-2"
                            >Ask A Question</span>
                        </span>
                    </div>
                    
                    <v-img              
                        v-if="$vuetify.breakpoint.smAndDown"          
                        contain
                        class="mt-6"
                        src="/general/home-banner-4.png" 
                                                                                            
                    ></v-img>

                    <div class="mt-6">
                        <h5 class="weight-bold font-24 darkergray--text text-center text-md-left">Download our App</h5>
                        <div class="mt-3" :align="$vuetify.breakpoint.mdAndUp ? 'left' : 'center'">
                            
                                <v-img
                                    width="150"
                                    src="/general/download-android-v3.png"                                                                     
                                    @click="goToPatientApp()"                                                                        
                                    class="cursor-pointer"
                            />
                            
                        </div>
                    </div>

                </v-col>

                <v-col cols="12" md="6" lg="6" class="d-inline-flex align-center" v-if="$vuetify.breakpoint.mdAndUp">
                    <v-img 
                    contain                    
                        src="/general/home-banner-4.png"                                                                     
                    ></v-img>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid class="pa-0">
            <div style="height:60px;border-radius:0% 0% 50% 50% / 0% 0% 90% 90%; background:#fff; position:relative;z-index:2;">
            </div>
            <div style="position:relative;background: transparent linear-gradient(180deg, #E9C68E7A 0%, #FFFFFF7A 100%) 0% 0% no-repeat;margin-top:-60px;">
                <v-container v-if="$vuetify.breakpoint.mdAndUp">
            
                    <v-row style="padding-top:100px;">
                
                        <v-col cols="12" sm="12" md="12">                                                                                    
                                    <v-row no-gutters>
                                        <v-col md="7">
                                            <v-autocomplete
                                                class="docauto"
                                                flat
                                                v-model="searchDoctorRequest.doctorOrSpeciality"
                                                :items="searchDoctorRequest.doctorAndSpecializations"
                                                solo text
                                                prepend-inner-icon="mdi-account"
                                                color="#9b9b9b"
                                                dense
                                                item-text="name"
                                                item-value="id"
                                                :allow-overflow="false"
                                                return-object
                                                clearable
                                                :search-input.sync="searchDoctorRequest.searchSync"
                                                placeholder="Search For Doctor or Specialization..."
                                        >
                                            <template v-slot:item="data">
                                                <template v-if="typeof data.item !== 'object'">
                                                    <v-list-item-content v-text="data.item"></v-list-item-content>
                                                </template>
                                                <template v-else>
                                                    <v-list-item-avatar>
                                                        <v-avatar class="white--text primary">{{ data.item.name[0] }}</v-avatar>
                                                    </v-list-item-avatar>
                                                    <v-list-item-content>
                                                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                                        <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </template>
                                            </template>
                                        </v-autocomplete>
                                        </v-col>

                                        <v-col md="3" class="my-0 py-0 pl-4">                                
                                            <div class="d-flex align-center">
                                                
                                                <place-autocomplete
                                                    ref="place_autocomplete"
                                                    :place_name="placeFilter.place_name"
                                                    v-on:placechanged="getAddressData"
                                                    v-on:placeLoading="placeFilter.loading = true"
                                                    v-on:placeLoadingDone="placeFilter.loading = false"
                                                    v-on:locationRemoved="removeLocation"
                                                ></place-autocomplete>
                                                
                                                
                                            </div>
                                        </v-col>
                                        <v-col md="2" class="pl-4 d-flex justify-end">
                                            <v-btn color="white" 
                                                :disabled="placeFilter.loading" 
                                                :loading="placeFilter.loading" 
                                                outlined 
                                                class="searchbtn white--text weight-semibold secondaryVariant" 
                                                style="width:100%"
                                                @click="searchPressed(false)"
                                            >
                                                <template v-slot:loader>
                                                    <v-progress-circular
                                                            
                                                            color="white"
                                                            indeterminate
                                                    ></v-progress-circular>
                                                </template>
                                                Search
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    
                            
                        </v-col>
                                        
                    </v-row>
                </v-container>
                <v-container v-else>
            
                    <v-row style="padding-top:100px;">
                
                        <v-col cols="12" sm="12" md="12">                                                                                    
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                class="docauto"
                                                flat
                                                v-model="searchDoctorRequest.doctorOrSpeciality"
                                                :items="searchDoctorRequest.doctorAndSpecializations"
                                                solo text
                                                prepend-inner-icon="mdi-account"
                                                color="#9b9b9b"
                                                dense
                                                item-text="name"
                                                item-value="id"
                                                :allow-overflow="false"
                                                return-object
                                                clearable
                                                :search-input.sync="searchDoctorRequest.searchSync"
                                                placeholder="Search For Doctor or Specialization..."
                                        >
                                            <template v-slot:item="data">
                                                <template v-if="typeof data.item !== 'object'">
                                                    <v-list-item-content v-text="data.item"></v-list-item-content>
                                                </template>
                                                <template v-else>
                                                    <v-list-item-avatar>
                                                        <v-avatar class="white--text primary">{{ data.item.name[0] }}</v-avatar>
                                                    </v-list-item-avatar>
                                                    <v-list-item-content>
                                                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                                        <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </template>
                                            </template>
                                        </v-autocomplete>
                                        </v-col>

                                        <v-col cols="12" class="my-0 py-0 mt-1">                                
                                            <div class="d-flex align-center">                                            
                                                
                                                <place-autocomplete
                                                    ref="place_autocomplete"
                                                    :place_name="placeFilter.place_name"
                                                    v-on:placechanged="getAddressData"
                                                    v-on:placeLoading="placeFilter.loading = true"
                                                    v-on:placeLoadingDone="placeFilter.loading = false"
                                                    v-on:locationRemoved="removeLocation"
                                                ></place-autocomplete>
                                                
                                                
                                            </div>
                                        </v-col>
                                        <v-col cols="12" class="mt-4" align="center">
                                        

                                            <v-btn 
                                                :disabled="placeFilter.loading" 
                                                :loading="placeFilter.loading" 
                                                outlined 
                                                class="searchbtn white--text weight-semibold secondaryVariant"
                                                @click="searchPressed(false)"
                                            >
                                                <template v-slot:loader>
                                                    <v-progress-circular
                                                            
                                                            color="white"
                                                            indeterminate
                                                    ></v-progress-circular>
                                                </template>
                                                Search
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    
                            
                        </v-col>
                                        
                    </v-row>
                </v-container>
            </div>


        </v-container>
        
        <v-container class="mt-10">
            <v-row >         
                <v-col cols="12" md="4" lg="6">
                    <h1 v-if="$vuetify.breakpoint.mdAndUp" class="rfont-40 weight-semibold darkergray--text" style="line-height:1.3;">
                        Instant appointment with<br>Doctors. <br v-if="$vuetify.breakpoint.xs"><span class="secondaryVariant--text weight-extrabold">Guaranteed.</span>
                    </h1>
                    <h1 v-else class="rfont-40 weight-semibold darkergray--text text-center" style="line-height:1.3;">
                        Instant appointment with Doctors. <span class="secondaryVariant--text weight-extrabold">Guaranteed.</span>
                    </h1>
                    <h6 class="rfont-18 weight-medium darkergray--text mt-5 text-center text-md-left" style="line-height:1.5;">
                        Your certified doctor on your phone. Consult with verified doctors. 100% private and confidential. India's best online appointment scheduling platform for e-Consultation.
                    </h6>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">

                    <v-row no-gutters>

                        <v-col cols="12">
                            <v-card
                                style="width:100%"
                                color="#fff"
                                class="d-inline-flex align-center rounded px-4 py-4 card-shadow"
                                
                            >
                                
                                <span
                                    class="d-inline-flex align-center"    
                                >
                                    <v-responsive :aspect-ratio="1/1" style="width:70px;height:70px;">
                                            <span class="">
                                                <div style="width:100%;height:100%;background:#C8E2FF;border-radius:2000px;">
                                                <v-img
                                                    style="top:50%;left:50%;transform:translate(-50%,-50%);"
                                                    width="40"
                                                    height="40"
                                                    src="/general/ic_correct.png"                                                                     
                                                ></v-img>
                                                </div>                                            
                                            </span>
                                    </v-responsive>
                                    
                                    
                                    
                                    <span                                
                                        class="rfont-20 darkergray2--text weight-semibold ml-4"
                                    >500+ Verified<br>Doctors</span>
                                </span>                        
                            </v-card>
                        </v-col>

                        <v-col cols="12">
                            <v-card
                                style="width:100%"
                                color="#fff"
                                class="d-inline-flex align-center rounded px-4 py-4 card-shadow mt-8"
                                
                            >
                                
                                <span
                                    class="d-inline-flex align-center"    
                                >
                                    <v-responsive :aspect-ratio="1/1" style="width:70px;height:70px;">
                                        <span>
                                            <div style="width:100%;height:100%;background:#E7F5E7;border-radius:2000px;">
                                            <v-img
                                                style="top:50%;left:50%;transform:translate(-50%,-50%);"
                                                width="40"
                                                src="/general/ic_thumbsup.png"                                                                     
                                            ></v-img>
                                            </div>
                                            
                                        </span>
                                    </v-responsive>
                                    
                                    <span                                
                                        class="rfont-20 darkergray2--text weight-semibold ml-4"
                                        style="word-break:break-all;"
                                    >Consult with<br>doctors 24x7</span>
                                </span>                        
                            </v-card>
                        </v-col>
                    </v-row>
                    
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="mt-md-8">

<v-row no-gutters>
    <v-col cols="12">
        <v-card
            style="width:100%"
            color="#fff"
                class="d-inline-flex align-center rounded px-4 py-4 card-shadow"
            
        >
            
            <span
                class="d-inline-flex align-center"    
            >
            <v-responsive :aspect-ratio="1/1" style="width:70px;height:70px;">
                    <span>
                        <div style="width:100%;height:100%;background:#E9C68E69;border-radius:2000px;">
                        <v-img
                            style="top:50%;left:50%;transform:translate(-50%,-50%);"
                            width="40"
                            src="/general/ic_data.png"                                                                     
                        ></v-img>
                        </div>
                        
                    </span>
            </v-responsive>
                
                <span                                
                    class="rfont-20 darkergray2--text weight-semibold ml-4"
                >256-bit<br>encryption</span>
            </span>                        
        </v-card>
    </v-col>

    <v-col cols="12">
        <v-card
            style="width:100%"
            color="#fff"
                class="d-inline-flex align-center rounded px-4 py-4 card-shadow mt-8"
            
        >
            
            <span
                class="d-inline-flex align-center"    
            >
                <v-responsive :aspect-ratio="1/1" style="width:70px;height:70px;">
                    <span >
                        <div style="width:100%;height:100%;background:#E6F2FFCE;border-radius:2000px;">
                        <v-img
                            style="top:50%;left:50%;transform:translate(-50%,-50%);"
                            width="40"
                            src="/general/ic_servr.png"                                                                     
                        ></v-img>
                        </div>
                        
                    </span>
                </v-responsive>
                
                
                <span                                
                    class="rfont-20 darkergray2--text weight-semibold ml-4"
                >HIPAA compliant<br>data centers</span>
            </span>                        
        </v-card>
    </v-col>
</v-row>
                    

                    

                </v-col>
            </v-row>
        </v-container>
       
       


        <v-container fluid class="mt-12" >
            <v-container class="">
                <v-row class="home-rows" align="center">
                    <v-col cols="12" sm="12" md="12" class="text-center">
                        <h1 class="rfont-32 darkergray--text playfair-display weight-semibold">Consult with top doctors across specialities</h1>                        
                    </v-col>
                    <v-col cols="12" sm="12" md="10" offset-md="1" class="text-center">
                        <h6 class="rfont-20 darkergray--text playfair-display weight-medium">HealthyAlways gives access to remote healthcare in one touch. Without leaving your home, wherever you are, use your phone or computer and connect to the doctor, anytime, anywhere!</h6>
                    </v-col>                                   
                </v-row>

                <v-row>

                    <v-col cols="12" class="text-center">                    
                        <v-carousel                     
                            height="auto" 
                            hide-delimiters
                        >
                            <template v-slot:prev="{ on, attrs }">
                                
                                <v-btn
                                v-bind="attrs"
                                    v-on="on"
                                color="white"
                                fab
                                x-small
                                dark
                                >
                                    <v-icon class="darkergray--text" >mdi-chevron-left</v-icon>
                                </v-btn>
                                </template>
                                <template v-slot:next="{ on, attrs }">
                                    <v-btn
                                    v-bind="attrs"
                                        v-on="on"
                                    color="white"
                                    fab
                                    x-small
                                    dark
                                    >
                                        <v-icon class="darkergray--text" >mdi-chevron-right</v-icon>
                                    </v-btn>
                                </template>
                            <v-carousel-item                                  
                                v-for="(specialitySubList,i1) in specialitiesObj.specialities"                                
                                :key="i1"
                            >
                            
                                <v-row
                                    class="mx-10"                   
                                >
                                    <v-col 
                                        v-for="(speciality,i2) in specialitySubList"                                        
                                        :key="i2"
                                        :cols="specialitiesObj.cols">
                                            <v-card                                                
                                                class="card-shadow-2 mx-1 my-12 px-1 rounded"
                                                color="white"
                                                
                                            >
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-img      
                                                        style="margin:auto;max-width:60px;"                                              
                                                            :src="getImagePath(speciality.image)"                                                        
                                                            width="60%"                                                        
                                                        ></v-img>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <div 
                                                            class="weight-semibold darkergray--text"
                                                            v-bind:class="{'rfont-18' : speciality.name.length <= 12,'rfont-16': speciality.name.length >= 12}"
                                                        >                                                            
                                                                {{speciality.name}}
                                                         
                                                        </div>
                                                        <div class="weight-medium rfont-12 primaryVariant--text d-flex justify-center align-center mt-2 cursor-pointer" @click="goToSpecialityFromSpecialitySection(speciality)">
                                                            <span class="mr-1 cursor-pointer">Consult Now </span>
                                                            <v-icon small class="primaryVariant--text mx-0 px-0" style="width:8px">mdi-chevron-right</v-icon>
                                                            <v-icon small class="primaryVariant--text mx-0 px-0" style="width:8px">mdi-chevron-right</v-icon>
                                                        </div>
                                                    </v-col>
                                                </v-row>                                            
                                            </v-card>
                                    </v-col>
                                
                                </v-row>
                            
                            </v-carousel-item>
                            
                        </v-carousel>
                    </v-col>             
                </v-row>
            </v-container>
        </v-container>

        <v-container fluid class="pa-0 mt-12"            
            :class="{ 'bg-symptoms' :  $vuetify.breakpoint.mdAndUp}"
            :style="$vuetify.breakpoint.smAndDown ? 'background:#f6e9d4' : ''"
        >            
        
            <v-container             

            >
                <v-row>
                <v-col cols="12" class="align-self-center px-12" v-if="$vuetify.breakpoint.smAndDown">
                    <h1 class="text-center text-md-left rfont-40 weight-semibold darkergray--text" style="line-height:1.3;">
                        Common health concerns
                    </h1>
                    <h6 class="text-center text-md-left rfont-18 weight-medium darkergray--text mt-5" style="line-height:1.5;">
                        Specialised healthcare professionals to overcome your health concerns in seconds by getting an appointment fixed with Indias best doctors.
                    </h6>
                </v-col>
                    <v-col cols="12" sm="6" md="2" class="px-8 px-sm-2">

                        <div 
                            class="mt-8 ma-2"                            
                            v-for="(data,i) in symptomsObj.col1"
                            :key="i"
                        >                    
                            <v-responsive :aspect-ratio="1/1" style="border-radius:20px;">
                                <div class="fill-height" :style="`background:url(${data.img});background-repeat:no-repeat;background-size:cover;background-postion:center center;`">
                                    <div style="width:100%;height:100%;" class="d-flex flex-column justify-end px-4 pb-4">
                                        <div class="accent--text weight-semibold"
                                            :class="{'rfont-14' : $vuetify.breakpoint.mdAndUp, 'rfont-24': $vuetify.breakpoint.smAndDown}"
                                        >
                                            {{ data.title }}
                                        </div>
                                        <div class="weight-medium primary--text d-flex cursor-pointer"
                                            :class="{'rfont-12' : $vuetify.breakpoint.mdAndUp, 'rfont-18': $vuetify.breakpoint.smAndDown}"
                                         @click="goToSpecialityFromSymptomsSection(data.speciality)">
                                            <span class="mr-1 cursor-pointer">Consult Now </span>
                                            <v-icon small class="primary--text mx-0 px-0" style="width:8px">mdi-chevron-right</v-icon>
                                            <v-icon small class="primary--text mx-0 px-0" style="width:8px">mdi-chevron-right</v-icon>
                                        </div>
                                    </div>
                                </div>                            
                            </v-responsive>                        
                        </div>                                                                
                    </v-col>
                    <v-col cols="12" offset-sm="0" sm="6" md="2" style="height:fit-content;" class="align-self-md-center px-8 px-sm-2">

                        <div 
                            class="mt-8 ma-2"
                            v-for="(data,i) in symptomsObj.col2"
                            :key="i"
                        >                    
                            <v-responsive :aspect-ratio="1/1" style="border-radius:20px;">
                                <div class="rounded-lg fill-height" :style="`background:url(${data.img});background-repeat:no-repeat;background-size:cover;background-postion:center center;`" >
                                    <div style="width:100%;height:100%;" class="d-flex flex-column justify-end px-4 pb-4">
                                        <div class="accent--text weight-semibold"
                                            :class="{'rfont-14' : $vuetify.breakpoint.mdAndUp, 'rfont-24': $vuetify.breakpoint.smAndDown}"
                                        >
                                            {{ data.title }}
                                        </div>
                                        <div class="weight-medium primary--text d-flex" @click="goToSpecialityFromSymptomsSection(data.speciality)"
                                            :class="{'rfont-12' : $vuetify.breakpoint.mdAndUp, 'rfont-18': $vuetify.breakpoint.smAndDown}"
                                        >
                                            <span class="mr-1 cursor-pointer">Consult Now </span>
                                            <v-icon small class="primary--text mx-0 px-0" style="width:8px">mdi-chevron-right</v-icon>
                                            <v-icon small class="primary--text mx-0 px-0" style="width:8px">mdi-chevron-right</v-icon>
                                        </div>
                                    </div>
                                </div>                            
                            </v-responsive>                        
                        </div>                                                                
                    </v-col>
                    <v-col cols="12" md="7" class="align-self-center ml-md-12" v-if="$vuetify.breakpoint.mdAndUp">
                        <h1 class="rfont-40 weight-semibold darkergray--text" style="line-height:1.3;">
                            Common health concerns
                        </h1>
                        <h6 class="rfont-18 weight-medium darkergray--text mt-5" style="line-height:1.5;">
                            Specialised healthcare professionals to overcome your health concerns in seconds by getting an appointment fixed with Indias best doctors.
                        </h6>
                    </v-col>
                </v-row>                
            </v-container>
            
        </v-container>

        
       <v-container fluid class="pa-0 mt-12 mt-md-0 mg-lg-0"            
            :class="{ 'bg-book-apt' :  $vuetify.breakpoint.mdAndUp}"
            :style="$vuetify.breakpoint.smAndDown ? 'background:#f7fbff' : ''"
        >      

            <v-container class="py-0">
                <v-row>

                    <v-col cols="12" md="6" class="align-self-center">
                        <h1 v-if="$vuetify.breakpoint.mdAndUp" class="rfont-40 weight-semibold darkergray--text" style="line-height:1.3;">
                            Book appointments with top<br>professionals near you
                        </h1>
                        <h1 v-else class="text-center rfont-40 weight-semibold darkergray--text" style="line-height:1.3;">
                            Book Appointments With Top Professionals Near You
                        </h1>
                        <h6 class="text-center text-md-left rfont-18 weight-medium darkergray--text mt-5" style="line-height:1.5;">
                            We’ll help you connect with prominent and reputed healthcare professionals in just a few clicks.
                        </h6>
                        <div class="d-flex justify-center justify-md-start">
                            <v-btn class=" primaryVariant white--text weight-semibold rfont-14 mt-5" large ripple @click="$router.push({name: 'searchDoctor', query:{video:1}})">
                                Book An Appointment                            
                            </v-btn>
                        </div>
                        
                    </v-col>

                    <v-col cols="12" md="6" class="align-self-center pt-md-12 pb-md-12">
                        <v-img                                      
                        src="/general/img_book_apt.png"                                                                     
                    ></v-img>
                    </v-col>
                </v-row>


            </v-container>

        </v-container>

        <v-container fluid class="pa-0"
            v-if="$vuetify.breakpoint.mdAndUp"
            :style="{
                minHeight:$vuetify.breakpoint.mdAndUp ? '300px' : '0px',
                marginTop:$vuetify.breakpoint.mdAndUp ? '-120px' : '0px' 
            }"
        >      

            <v-container class="pa-0">
                <v-row no-gutters> 
                    <v-col cols="12" class="d-flex justify-end">
                        <v-img                                              
                            max-width="420px"                            
                            width="420px"                            
                            src="/general/img_stethoscope.png"                                                                     
                            style="z-index:1;"
                            :style="{
                                marginRight:$vuetify.breakpoint.lg ? '-120px' : '-150px',                                
                            }"
                        ></v-img>
                    </v-col>                
                </v-row>                
                    
            </v-container>
           

          

        </v-container>

        <v-container fluid :style="{marginTop:$vuetify.breakpoint.mdAndUp ? '-220px' : '32px' }" >        
        
            <v-container class="">
                <v-row class="home-rows" align="center">
                    <v-col cols="12" sm="12" md="12" class="text-center">
                        <h1 class="rfont-32 darkergray--text playfair-display weight-semibold">Trending care options</h1>                        
                    </v-col>                    
                </v-row>

                <v-row>

                    <v-col cols="12" class="text-center pt-0">                    
                        <v-carousel                     
                            height="auto" 
                            hide-delimiters
                        >
                            <template v-slot:prev="{ on, attrs }">
                                
                                <v-btn
                                v-bind="attrs"
                                    v-on="on"
                                color="white"
                                fab
                                x-small
                                dark
                                >
                                    <v-icon class="darkergray--text" >mdi-chevron-left</v-icon>
                                </v-btn>
                                </template>
                                <template v-slot:next="{ on, attrs }">
                                    <v-btn
                                    v-bind="attrs"
                                        v-on="on"
                                    color="white"
                                    fab
                                    x-small
                                    dark
                                    >
                                        <v-icon class="darkergray--text" >mdi-chevron-right</v-icon>
                                    </v-btn>
                                </template>
                            <v-carousel-item                                  
                                v-for="(subList,i1) in trendingCareObj.uiList"                                
                                :key="i1"
                            >
                            
                                <v-row
                                    class="mx-10"                   
                                >
                                    <v-col 
                                    class="pt-0"
                                        v-for="(care,i2) in subList"                                        
                                        :key="i2"
                                        :cols="trendingCareObj.cols">
                                            <v-card                                                
                                                class="card-shadow-2 mx-1 mb-12 px-4 rounded-xl"
                                                style="margin-top:100px;"
                                                color="white"
                                                
                                            >
                                                <v-row>
                                                    <v-col cols="12" class="d-flex justify-center pt-0" style="margin-top:-50px">
                                                        <v-responsive :aspect-ratio="1/1" class="rounded-circle elevation-6 d-flex justify-center align-center white" style="max-width:100px;">
                                                            <v-img     

                                                                style="margin:auto;max-width:60px;"                                              
                                                                :src="care.img"                                                            
                                                                contain
                                                                height="64px"
                                                            ></v-img>
                                                        </v-responsive>
                                                        
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <div 
                                                            class="weight-semibold darkergray--text"
                                                            v-bind:class="{'rfont-18' : care.title.length <= 12,'rfont-16': care.title.length >= 12}"
                                                        >                                                            
                                                                {{care.title}}
                                                         
                                                        </div>
                                                        <div class="weight-semibold rfont-12 secondaryVariant--text font-italic px-1 mt-3" >
                                                            <span style="background:#E7F5E7" class="pa-1">
                                                                {{care.subtitle}}
                                                            </span>
                                                        </div>
                                                         <div 
                                                            class="weight-medium darkergray--text rfont-16 mt-3"
                                                        >                                                            
                                                                {{care.desc}}
                                                         
                                                        </div>
                                                        
                                                        <div class="cursor-pointer weight-medium rfont-14 primaryVariant--text d-flex justify-center align-center mt-4 mb-4" @click="goToSpecialityFromTrendingNow(care)">
                                                            <span class="mr-1 cursor-pointer">Speak Now </span>
                                                            <v-icon small class="primaryVariant--text mx-0 px-0" style="width:8px">mdi-chevron-right</v-icon>
                                                            <v-icon small class="primaryVariant--text mx-0 px-0" style="width:8px">mdi-chevron-right</v-icon>
                                                        </div>
                                                    </v-col>
                                                </v-row>                                            
                                            </v-card>
                                    </v-col>
                                
                                </v-row>
                            
                            </v-carousel-item>
                            
                        </v-carousel>
                    </v-col>             
                </v-row>
            </v-container>
        </v-container>
        <v-container fluid class="pa-20" style="background:#f4e4c9">
            <v-container>
                    <v-row>
                    <v-col cols="12" sm="12" md="12">
                        <h1 class="font-32 playfair-display font-weight-bold darkergray--text text-center">Leading healthcare providers.<br>Trust us for business</h1>
                    </v-col>        
                    <v-col cols="12" sm="12" md="12"
                        v-if="$vuetify.breakpoint.smAndDown"
                    >
                        <v-img                                    
                            contain
                            src="/general/testimonials-banner-2.png">
                        </v-img> 
                    </v-col>                                        
                    
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="6" :class="{'mb-12': $vuetify.breakpoint.lg}">
                        <div style="position:relative;"
                            :style="$vuetify.breakpoint.lg ? 'max-width:600px' : ''"
                            
                        >
                            <v-list class="pa-2 py-6 wrap-normal-list" style="border-radius:20px;">
                                <!--                                <v-list-item-group color="primary">-->
                                <v-list-item>
                                    <v-list-item-icon class="mr-3">
                                        <v-img src="/general/ic_check_features.png" width="16" height="16" contain/>
                                        
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title class="darkergray--text rfont-16 weight-medium">
                                            The most advanced software for clinics and hospitals
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>      
                                <v-list-item>
                                    <v-list-item-icon class="mr-3">
                                        <v-img src="/general/ic_check_features.png" width="16" height="16" contain/>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title class="darkergray--text rfont-16 weight-medium" style="line-height:1.5;">
                                            State of the art business<br v-if="$vuetify.breakpoint.mdAndUp"><span v-else class="ml-1"></span>analytics for enterprises
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>      
                                <v-list-item>
                                    <v-list-item-icon class="mr-3">
                                        <v-img src="/general/ic_check_features.png" width="16" height="16" contain/>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title class="darkergray--text rfont-16 weight-medium" style="line-height:1.5;">
                                            Get seen by patients across<br v-if="$vuetify.breakpoint.mdAndUp"><span v-else class="ml-1"> </span>the globe on<br v-if="$vuetify.breakpoint.mdAndUp"><span v-else class="ml-1"></span>healthyalways.com
                                            
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>                                
                                
                            </v-list>
                            <div v-if="$vuetify.breakpoint.mdAndUp" :class="{'testimonial-banner-pos-lg': $vuetify.breakpoint.lg,'testimonial-banner-pos-md': $vuetify.breakpoint.md}">
                                <v-img                                    
                                    contain
                                    src="/general/testimonials-banner-2.png">
                                </v-img> 
                            </div>

                            
                        </div>
                    </v-col>                                                                           
                        <v-col cols="12" offset-md="2" md="4" class="text-center">                    
                        <v-carousel                     
                            height="auto" 
                            v-model="testimonialsObj.page"
                            :show-arrows="false"
                            hide-delimiters
                        >
                            <template v-slot:prev="{ on, attrs }">
                                
                                <v-btn
                                v-bind="attrs"
                                    v-on="on"
                                color="white"
                                fab
                                x-small
                                dark
                                >
                                    <v-icon class="darkergray--text" >mdi-chevron-left</v-icon>
                                </v-btn>
                                </template>
                                <template v-slot:next="{ on, attrs }">
                                    <v-btn
                                    v-bind="attrs"
                                        v-on="on"
                                    color="white"
                                    fab
                                    x-small
                                    dark
                                    >
                                        <v-icon class="darkergray--text" >mdi-chevron-right</v-icon>
                                    </v-btn>
                                </template>
                            <v-carousel-item                                  
                                v-for="(testimonial,i1) in testimonialsObj.uiList"                                
                                :key="i1"
                            >
                                                                                           
                                <v-row class="ma-0">                                                    
                                    <v-col cols="12" class="py-8 px-0" style="background:#fff; border-radius:20px;">
                                        <div 
                                            class="weight-regular darkergray--text rfont-14 text-left px-8 py-2"
                                            style="line-height:1.8;max-height:140px;overflow-y:auto"
                                        >                                                            
                                                {{testimonial.testimonial}}
                                            
                                        </div>
                                        <div 
                                            class="weight-bold darkergray--text rfont-16 text-left px-8 mt-3"
                                            style="line-height:1.8;"
                                        >                                                            
                                                {{testimonial.name}}
                                            
                                        </div>
                                        <div 
                                            class="weight-medium darkergray--text rfont-12 text-left px-8"
                                            style="line-height:1.8;"
                                        >                                                            
                                                {{testimonial.position}}
                                            
                                        </div>
                                    </v-col>
                                </v-row>                                            
                                
                        
                            </v-carousel-item>
                            
                        </v-carousel>
                        <div class="d-flex justify-end mt-4 mr-2">
                            <v-icon color="white" v-if="testimonialsObj.page==0"> mdi-arrow-left</v-icon>
                            <v-icon v-else right @click="testimonialsObj.page--"> mdi-arrow-left</v-icon>
                            
                            <v-icon v-if="testimonialsObj.page==testimonialsObj.uiList.length-1" color="white">mdi-arrow-right</v-icon>
                            <v-icon v-else right @click="testimonialsObj.page++">mdi-arrow-right</v-icon>
                        </div>
                    </v-col>                                                                            
                                                                                            

                </v-row>
                        

            </v-container>
        
        </v-container>
        
         <v-container fluid class="pa-0 d-flex align-center " style="background:url('/general/app-down-bg-2.png');background-position:center center;position:relative; min-height:502px;"
            :style="{'marginTop' : $vuetify.breakpoint.lg ? '120px' : '10px'}"
         >

            <v-container>
                <v-row>
                    <v-col cols="12" md="6" class="d-flex align-center">
                        <v-row no-gutters>
                            <v-col cols="12" md="12">
                                <h5 class="weight-bold font-24 darkergray--text">Download HealthyAlways App</h5>
                            </v-col>
                            <v-col cols="12" md="6" class="pl-0 ml-n2">
                                <v-list class="wrap-normal-list" style="background:transparent">
                                    <v-list-item                        
                                        class="pl-0"
                                        style="min-height:10px"
                                        v-for="(obj,i) in downloadAppObj.col1"
                                        :key="i"
                                    >
                                        <v-list-item-icon class="mr-3 my-0 align-self-center">
                                            <v-icon color="primaryVariant" rounded>mdi-chevron-right</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content class="my-0">
                                            <v-list-item-title class="darkergray--text rfont-16 weight-medium py-0">
                                                {{obj.desc}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>         
                                    <template v-if="$vuetify.breakpoint.smAndDown"   >
                                            <v-list-item                     
                                        
                                                class="pl-0"
                                                style="min-height:10px"
                                                v-for="(obj,i) in downloadAppObj.col2"
                                                :key="i"
                                            >
                                                <v-list-item-icon class="mr-3 my-0 align-self-center">
                                                    <v-icon color="primaryVariant" rounded>mdi-chevron-right</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content class="my-0">
                                                    <v-list-item-title class="darkergray--text rfont-16 weight-medium py-0">
                                                        {{obj.desc}}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>   
                                    </template>
                                                                                                
                                </v-list>
                            </v-col>

                            <v-col cols="12" md="6" class="ml-n2" v-if="$vuetify.breakpoint.mdAndUp">                    
                                <v-list class="wrap-normal-list" style="background:transparent">
                                    <v-list-item                        
                                        class="pl-0"
                                        style="min-height:10px"
                                        v-for="(obj,i) in downloadAppObj.col2"
                                        :key="i"
                                    >
                                        <v-list-item-icon class="mr-3 my-0 align-self-center">
                                            <v-icon color="primaryVariant" rounded>mdi-chevron-right</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content class="my-0">
                                            <v-list-item-title class="darkergray--text rfont-16 weight-medium py-0">
                                                {{obj.desc}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>                                                                
                                </v-list>
                            </v-col>
                            <v-col cols="12" md="12" class=" mt-4">        
                                
                                <v-img
                                    width="150"
                                    src="/general/download-android-v3.png"                                                                     
                                    @click="goToPatientApp()"                                    
                                    class="cursor-pointer"
                                />
                                
                            </v-col>
                        </v-row> 
                    </v-col>
                    

                    
                </v-row>
       
            </v-container>

        </v-container>

       


        <!--        Convenience -->
        <v-container fluid class="lightBackground px-0" v-if="0===1">
            <v-container class="">
                <v-row style="min-height: 60vh" class="home-rows" align="center">
                    <v-col cols="12" sm="12" md="6">
                        <h1 class="font-32 playfair-display font-weight-bold">Convenience when you need it most.</h1>
                        <br>
                        <h2 class="font-weight-regular font-26 opacity-8">
                            Receive care at the comfort of your home.
                            Schedule in home lab tests.
                        </h2>

                        <br class="hidden-sm-and-down">
                        <br>
                        <h2 class="">
                            <v-btn class="accent white--text" rounded large ripple>
                                Schedule Lab Tests
                                <v-icon right> mdi-arrow-right</v-icon>
                            </v-btn>
                        </h2>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" class="hidden-sm-and-down">
                        <!--                        <v-card flat>-->
                        <v-img src="../assets/home/banner-4.png" width="100%"></v-img>
                        <!--                        </v-card>-->
                    </v-col>
                </v-row>
            </v-container>
        </v-container>


    
       
        <!--        Articles -->
        <!-- <v-container fluid class="lightPinkBackground">
            <v-container class="">
                <v-row style="min-height: 60vh" class="home-rows" align="center">
                    <v-col cols="12" sm="12" md="12" class="text-center">
                        <h1 class="font-32 playfair-display font-weight-bold">The Latest from Healthy Always</h1>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                        <v-card>
                            <v-img
                                    class="white--text align-end"
                                    height="200px"
                                    src="../assets/home/articles/teeth-sensitivity.jpg"
                            >
                            </v-img>

                            <v-card-title class="accent-gradient--text">Dental Hygiene</v-card-title>
                            <v-card-text class="text--primary">
                                <div>
                                    Common causes of teeth sensitivity. How to keep your teeth healthy!
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                        <v-card>
                            <v-img
                                    class="white--text align-end"
                                    height="200px"
                                    src="../assets/home/articles/keep-eyes-healthy.jpg"
                            >
                            </v-img>

                            <v-card-title class="accent-gradient--text font-weight-bold">Healthy Eyes</v-card-title>
                            <v-card-text class="text--primary">
                                <div>
                                    How to keep your sensitive eyes healthy and clean
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                        <v-card>
                            <v-img
                                    class="white--text align-end"
                                    height="200px"
                                    src="../assets/home/articles/joint-pain.jpg"
                            >
                            </v-img>

                            <v-card-title class="accent-gradient--text font-weight-bold">Joint Pain</v-card-title>
                            <v-card-text class="text--primary">
                                <div>
                                    Tips to get joint pain relief in this chilling winter
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="12" md="3">
                        <v-card>
                            <v-img
                                    class="white--text align-end"
                                    height="200px"
                                    src="../assets/home/articles/homeopathy-image.jpg"
                            >
                            </v-img>

                            <v-card-title class="accent-gradient--text font-weight-bold">Homeopathy</v-card-title>
                            <v-card-text class="text--primary">
                                <div>Homeopathy for common cold, cough and other issues</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container> -->

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import PlaceAutocomplete from '../components/PlaceAutocomplete.vue';
    export default {
        name: "Home",
        components: {
            PlaceAutocomplete
        },
        computed: {
            ...mapGetters([          
                'userInfo'
            ]),
        },
        mounted() {
            var paramurl="http://localhost:8081/appointment-call/279e4a8a-eaca-4f97-a81d-88e05f60a978"
            var url = new URL("http://localhost:8080/")
            url.searchParams.set('redirect', paramurl);                        
            
            this.getSpecialities()
           this.updateTrendingCareUiData()

        },

        data() {
            return {
                block: 1,
                patient_app_link:process.env.VUE_APP_API_URL+"/app/patient",
                specialitiesObj:{
                    specialities:[],
                    originalSpecialitiesList:[],
                    itemsPerPage:0,
                    cols:6
                },
                trendingCareObj:{
                    uiList:[],
                    originalList:[                        
                        {
                            id:"2",
                            title:"Hair Loss",
                            subtitle:"Get attention when you need it.",
                            desc:"Speak to our team of Dermatologist about Hair loss- Hair thinning.",
                            img:"/general/ic_allergist.png",
                            speciality_name:"Dermatologist",                            
                            speciality_id:"d622d3f0-7673-4387-96b2-e299ddf471b2"
                            
                        },
                        {
                            id:"3",
                            title:"Diabetes",
                            subtitle:"Get attention when you need it.",
                            desc:"Speak to our Experienced team of Endocrinologist for health risks related to Diabetes.",
                            img:"/general/ic_allergist.png",
                            speciality_name:"Endocrinologists",                            
                            speciality_id:"d3019a1e-d9d7-4a63-8eae-77e31b9419fe"                            
                        },
                        {
                            id:"4",
                            title:"Homoepathy",
                            subtitle:"Get attention when you need it.",
                            desc:"Speak to our Homoepaths for your problems related to long term illness.",
                            img:"/general/ic_allergist.png",
                            speciality_name:"Homeopathy",                            
                            speciality_id:"84145e60-72ba-4a3d-bc77-a2abeb1807ca"                            
                        },
                        {
                            id:"5",
                            title:"Pediatrics",
                            subtitle:"Get attention when you need it.",
                            desc:"Speak to our Pediatric Expert for all the health related issues of your young loved ones.",
                            img:"/general/ic_allergist.png",
                            speciality_name:"Pediatrics",                            
                            speciality_id:"2a54b249-ffec-4d2f-a8e5-da77263796ae"                            
                        },
                        {
                            id:"6",
                            title:"Oncology",
                            subtitle:"Get attention when you need it.",
                            desc:"Speak to our certified Oncologists to get better care over cancer related problems.",
                            img:"/general/ic_allergist.png",
                            speciality_name:"Oncologist",                            
                            speciality_id:"0048f713-2dbf-41d3-91e7-5be074074958"                            
                        }                        
                    ],
                    itemsPerPage:0,
                    cols:6
                },
                testimonialsObj:{
                    page:0,
                    uiList:[
                        {
                            id:"1",
                            testimonial:"The service is so quick and professional and saves hours spent in a walk-in-clinic. This is a game changer in Virtual Health Consultations. Must be a part of this!",
                            name:"Rishab Paneria",
                            position:"Marketing Executive",
                        },
                        {
                            id:"1",
                            testimonial:"Our family has used this service twice so far and it has been amazing. Both Doctors were friendly, compassionate and you never feel rushed.",
                            name:"Akshay Zhunjare",
                            position:"CEO",                            
                        },
                        {
                            id:"1",
                            testimonial:"Absolutely blown away. It was so easy to use. No wait time like a clinic, selected a time from the doctors working hours and the doctor gave me a call from his end. It’s a seamless process.",
                            name:" Harsimran Waliya",
                            position:"Director",                            
                        },
                    ],                    
                    itemsPerPage:1,
                    cols:12
                },
                symptomsObj:{
                    col1:[
                        {
                            img:"/general/img_cold_cough.png",
                            title:"Cold and Cough",
                            speciality:{
                                id:"7bd17e90-a369-4321-88b2-c4e1c84f721e",
                                name:"ENT Specialist"
                            }
                        },
                        {
                            img:"/general/img_skin_problem.png",
                            title:"Skin problem",
                            speciality:{
                                id:"d622d3f0-7673-4387-96b2-e299ddf471b2",
                                name:"Dermatologist"
                            }
                        },
                        {
                            img:"/general/img_sick_kid.png",
                            title:"Sick kid",
                            speciality:{
                                id:"7bd17e90-a369-4321-88b2-c4e1c84f721e",
                                name:"ENT Specialist"
                            }
                        }
                    ],
                    col2:[
                        {
                            img:"/general/img_lose_weight.png",
                            title:"Want to lose weight",
                            speciality:{
                                id:"f8da41ea-4e11-432d-bd29-dd4b372bc636",
                                name:"Nutritionist"
                            }
                        },
                        {
                            img:"/general/img_depression.png",
                            title:"Depression and anxiety",
                            speciality:{
                                id:"c50f4f2c-2ff1-4816-bcfb-55527d73ffa0",
                                name:"Psychiatrist"
                            }
                        }
                    ],
                },
                downloadAppObj:{
                    col1:[
                        {
                            desc:"Book appointments"
                        },
                        {
                            desc:"Order medicines"
                        },
                        {
                            desc:"Consult doctors online"
                        },
                    ],
                    col2:[
                        {
                            desc:"Set medicine reminders"
                        },
                        {
                            desc:"Store health records"
                        },
                        {
                            desc:"Read health tips"
                        },
                    ],
                },
                searchDoctorRequest: {
                    searchSync:"",
                    doctorOrSpeciality: {},
                    doctorAndSpecializations: [],
                    specialization_id: '',
                    name: '',
                    type:'',
                    gender:'',
                    city: 'Mumbai',
                    limit: 5,
                    formatType: 'pagination',
                }, 
                placeFilter:{
                    loading:false,
                    latitude:null,
                    longitude:null,
                    city:null,                    
                    place_name:""
                }, 
            }
        },
        watch:{
            "$vuetify.breakpoint.name":function(){     
                if(this.specialitiesObj.originalSpecialitiesList.length)           
                    this.updateSpecialitiesUiData()
                this.updateTrendingCareUiData()    
            },
            'searchDoctorRequest.searchSync':function(){
                clearTimeout(this._timerId)
                this._timerId = setTimeout(() => {
                    this.getDoctorAndSpecializationsForAutoComplete()
                }, 500)

            }
        },
        methods: {

            isStrEmpty(str) {
                return (!str || 0 === str.length);
            },
            getAddressComponents(place) {
                
                let premise = place.address_components.find(addressComponent => addressComponent.types.includes('premise'))
                let route = place.address_components.find(addressComponent => addressComponent.types.includes('route'))
                let sublocality = place.address_components.find(addressComponent => addressComponent.types.includes('sublocality'))
                let postal_code = place.address_components.find(addressComponent => addressComponent.types.includes('postal_code'))
                let city = place.address_components.find(addressComponent => addressComponent.types.includes('locality'))
                let state = place.address_components.find(addressComponent => addressComponent.types.includes('administrative_area_level_1'))
                let country = place.address_components.find(addressComponent => addressComponent.types.includes('country'))
                let address = place.formatted_address                
                
                
                let returnObject = {
                    premise: premise ? premise.long_name : null,
                    route: route ? route.long_name : null,
                    sublocality: sublocality ? sublocality.long_name : null,

                    postal_code: postal_code ? postal_code.long_name : null,
                    city: city ? city.long_name : null,
                    state: state ? state.long_name : null,
                    country: country ? country.long_name : null,
                    address: address ? address : null,
                    latitude: place.geometry.location.lat,
                    longitude: place.geometry.location.lng,
                    name:place.name
                }

                var new_address = "";
                if(!this.isStrEmpty(place.name)){
                    new_address = place.name
                }
                else{
                    var address_arr = []
                    if(!this.isStrEmpty(returnObject.premise))
                        address_arr.push(returnObject.premise)
                    if(!this.isStrEmpty(returnObject.route))
                        address_arr.push(returnObject.route)
                    if(!this.isStrEmpty(returnObject.sublocality))
                        address_arr.push(returnObject.sublocality)
                    
                    if(address_arr.length)
                        new_address = address_arr.join(",")
                    else
                        new_address = returnObject.address                    
                }
                returnObject.local_address = new_address
                
                return returnObject
            },
            searchPressed(){
                var filters = {}
                filters.city = this.placeFilter.city;
                filters.latitude = this.placeFilter.latitude;
                filters.longitude = this.placeFilter.longitude;
                filters.place_name = this.placeFilter.place_name;

                filters = JSON.stringify(filters)
                var tempDocSpeciality = JSON.stringify({
                    searchString: this.searchDoctorRequest.doctorOrSpeciality.name,
                    group: this.searchDoctorRequest.doctorOrSpeciality.group,
                    id: this.searchDoctorRequest.doctorOrSpeciality.id
                })

                this.$router.push({name: 'searchDoctor', query:
                {
                  filters: filters,                  
                  doctorOrSpeciality:tempDocSpeciality
                }
              })

            },
            getDoctorAndSpecializationsForAutoComplete(searchStr) {
                var search = ""
                if(searchStr == undefined)
                    search = this.searchDoctorRequest.searchSync
                else
                    search = searchStr
                return new Promise((resolve) => {
                    this.axios
                        .get(`${process.env.VUE_APP_API_URL}/api/doctor-speciality`, {
                            params: {
                                name:search,
                                type:this.searchDoctorRequest.type
                            }
                        })
                        .then((response) => {
                            this.searchDoctorRequest.doctorAndSpecializations = response.data.data.forAutocomplete;
                            
                            resolve(response.data.data.forAutocomplete)
                        }).catch((error) => {
                        console.log(error);
                    });
                })
            },
            removeLocation(){
                this.placeFilter.city = "";
                this.placeFilter.latitude = "";
                this.placeFilter.longitude = "";
                this.placeFilter.place_name = "";
                
            },
            getAddressData(place) {
                
                this.geoLocation = ""
                var location_data = this.getAddressComponents(place)
                
                this.placeFilter.city = location_data.city;
                this.placeFilter.latitude = location_data.latitude;
                this.placeFilter.longitude = location_data.longitude;
                this.placeFilter.place_name = location_data.name;

                
                this.geoLocation = location_data.local_address                                
            },
            goToPatientApp(){
                window.open(process.env.VUE_APP_API_URL+"/app/patient",)
            },
            getSpecialities() {
                
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/specializations/website-specialization`)
                .then((response) => {
                    if(response.data.status == 1){                                                  
                     this.specialitiesObj.originalSpecialitiesList = response.data.data
                     this.updateSpecialitiesUiData()
                    }                    
                    
                }).catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    
                })
            },
            updateSpecialitiesUiData(){
                var itemsPerPage = 0
                var cols = 6
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': itemsPerPage = 1; cols = 12; break
                    case 'sm': itemsPerPage = 2; cols = 6; break
                    case 'md': itemsPerPage = 4; cols = 3; break
                    case 'lg': itemsPerPage = 6; cols = 2; break
                    case 'xl': itemsPerPage = 6; cols = 2; break
                }
                this.specialitiesObj.itemsPerPage = itemsPerPage
                this.specialitiesObj.cols = cols
                console.log("itemsPerPage  = "+itemsPerPage)
                var list = []                
                
                var totalPages = this.specialitiesObj.originalSpecialitiesList.length / itemsPerPage
                var isOver = false

                for(var i=0 ; i < totalPages; i++){
                    var subList = []
                    for(var j=0; j < itemsPerPage; j++){
                        var index = (i * itemsPerPage) + j                
                        if(index == this.specialitiesObj.originalSpecialitiesList.length){                            
                            isOver = true
                            break
                        }                                                    
                        
                        subList.push(this.specialitiesObj.originalSpecialitiesList[index])                        
                        
                    }
                    if(subList.length)
                        list.push(subList)                    

                    if(isOver)
                        break
                    
                }                
                this.specialitiesObj.specialities = list
                
            },
            updateTrendingCareUiData(){
                console.log("ADASDASDQQ")
                var itemsPerPage = 0
                
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': itemsPerPage = 1;break;
                    case 'sm': itemsPerPage = 2;break;
                    case 'md': itemsPerPage = 3;break;
                    case 'lg': itemsPerPage = 3;break;
                    case 'xl': itemsPerPage = 3;break;
                }
                this.trendingCareObj.itemsPerPage = itemsPerPage
                this.trendingCareObj.cols = 12/itemsPerPage
                
                var list = []                
                
                var totalPages = this.trendingCareObj.originalList.length / itemsPerPage
                var isOver = false

                for(var i=0 ; i < totalPages; i++){
                    var subList = []
                    for(var j=0; j < itemsPerPage; j++){
                        var index = (i * itemsPerPage) + j                
                        if(index == this.trendingCareObj.originalList.length){                            
                            isOver = true
                            break
                        }                                                    
                        
                        subList.push(this.trendingCareObj.originalList[index])                        
                        
                    }
                    if(subList.length)
                        list.push(subList)                    

                    if(isOver)
                        break
                    
                }                
                this.trendingCareObj.uiList = list
                
            },            
            handleScroll() {
                let height = document.getElementById('video-image').clientHeight;
                // document.getElementById("video-image-wrapper").style.height = height + "px";
                document.getElementById("video-image-wrapper-main").style.height = height + "px";
            },
            showTrendingCare(block) {
                this.block = block;
            },
            letsGetStarted(){
                // this.$router.push({name: 'askAQuestion'})
                if(this.userInfo)
                    this.$router.push({name: 'searchDoctor', query:{video:1}})
                else
                    this.$router.push({name: 'patientLogin'})                    

            },
            goToSpecialityFromSymptomsSection(data_obj){
                var obj = {
                    searchString:data_obj.name,
                    group:"Specializations",
                    id:data_obj.id,
                }                    
                this.$router.push({name: 'searchDoctor',query:{ doctorOrSpeciality: JSON.stringify(obj) }})
            },
            goToSpecialityFromSpecialitySection(data_obj){
                var obj = {
                    searchString:data_obj.name,
                    group:"Specializations",
                    id:data_obj.id,
                }                    
                this.$router.push({name: 'searchDoctor',query:{ doctorOrSpeciality: JSON.stringify(obj) }})
            },
            goToSpecialityFromTrendingNow(data_obj){                
                    var obj = {
                        searchString:data_obj.speciality_name,
                        group:"Specializations",
                        id:data_obj.speciality_id,
                    }                    
                    this.$router.push({name: 'searchDoctor',query:{ doctorOrSpeciality: JSON.stringify(obj) }})
            }
        }
    }
</script>

<style scoped>
    .banner-cards {
        border: 3px solid #E9C68E !important;
    }

    .banner-cards .v-card__actions {
        padding: 4px 8px !important;
        border-radius: 0 !important;
    }

    .action-cards {
        box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        overflow: hidden;
    }

    .action-cards:hover {
        box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.2);
    }

    .trending-button-active::after {
        content: " ";
        position: absolute;
        left: 48%;
        bottom: -40px;
        border-top: 0px solid #f6f3f1;
        border-right: 12px solid transparent;
        border-bottom: 20px solid #f6f3f1;
        border-left: 13px solid transparent;
        -webkit-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        transform: translateX(-50%);
        opacity: 1;
        transition: all .4s;
    }

</style>